import React, { useContext } from 'react';
import { Container, Row } from 'react-bootstrap';
import styled from 'styled-components';
import Header from './Header';
import { OptionContext } from '../../contexts/OptionContext';

const ContainerCustom = styled(Container)`
  margin-top: 75px;
`;

const LayoutDiv = styled.div`
    height: 100%;
    overflow-y: auto;
    width: 100%;
`;

const Layout = ({ children }) => {
  const context = useContext(OptionContext);
  const { display } = context;

  return (
    <>
      <Header />
      <LayoutDiv>
        <ContainerCustom className={`flex-nowrap robot-full-layout ${display}`}>
          <Row className="mb-3 mb-md-7">
            {children}
          </Row>
        </ContainerCustom>
      </LayoutDiv>
    </>
  );
};

export default Layout;
